import { useEffect, useRef } from 'react';

interface SEOMetaProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
}

export default function SEOMeta({
  title,
  description,
  keywords,
  canonicalUrl,
  ogTitle,
  ogDescription,
  ogType = 'website',
}: SEOMetaProps) {
  const fullTitle = title.includes('逼特逼视频') ? title : `${title} | 逼特逼视频`;
  const canonical = canonicalUrl || 'https://www.bitbivideo.com';
  const mounted = useRef(false);

  useEffect(() => {
    mounted.current = true;

    document.title = fullTitle;

    const setMeta = (name: string, content: string, propName?: string) => {
      let el: HTMLMetaElement | null = null;
      if (propName) {
        el = document.querySelector(`meta[property="${propName}"]`);
      } else {
        el = document.querySelector(`meta[name="${name}"]`);
      }
      if (!el) {
        el = document.createElement('meta');
        if (propName) {
          el.setAttribute('property', propName);
        } else {
          el.setAttribute('name', name);
        }
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    if (keywords) setMeta('keywords', keywords);
    setMeta('', ogTitle || fullTitle, 'og:title');
    setMeta('', ogDescription || description, 'og:description');
    setMeta('', ogType, 'og:type');
    setMeta('', canonical, 'og:url');
    setMeta('', '逼特逼视频', 'og:site_name');
    setMeta('', 'zh_CN', 'og:locale');
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', ogTitle || fullTitle);

    let linkCanonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!linkCanonical) {
      linkCanonical = document.createElement('link');
      linkCanonical.setAttribute('rel', 'canonical');
      document.head.appendChild(linkCanonical);
    }
    linkCanonical.setAttribute('href', canonical);

    return () => {
      mounted.current = false;
    };
  }, [fullTitle, description, keywords, canonical, ogTitle, ogDescription, ogType]);

  return null;
}